document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-postcard-builder]').forEach(initPostcardBuilder);
});

function initPostcardBuilder(root) {
  const sectionId = root.dataset.sectionId;
  const sizeInputs = Array.from(root.querySelectorAll('[data-postcard-size-input]'));
  const motifs = Array.from(root.querySelectorAll('[data-postcard-motif]'));
  const progressEl = root.querySelector('[data-postcard-progress]');
  const targetEl = root.querySelector('[data-postcard-target]');

  const productForm = document.getElementById('product-form-' + sectionId);
  const priceContainer = document.getElementById('price-' + sectionId);

  if (sizeInputs.length === 0 || motifs.length === 0 || !productForm) return;

  const addButton = productForm.querySelector('[name="add"]');
  const addButtonText = productForm.querySelector('[name="add"] staged-action-text');
  const buttonsContainer = productForm.querySelector('.js-product-buttons');
  const variantIdInput = productForm.querySelector('input[name="id"]');

  // Container für die versteckten properties[...]-Felder (Motive + Set-Größe),
  // wird bei jeder Änderung neu befüllt und lebt im selben Formular wie der echte Buy-Button
  const hiddenFieldsContainer = document.createElement('div');
  hiddenFieldsContainer.hidden = true;
  hiddenFieldsContainer.dataset.postcardHiddenFields = '';
  productForm.appendChild(hiddenFieldsContainer);

  const state = {
    target: 0,
    variantId: null,
    variantAvailable: true,
    counts: motifs.map(function () {
      return 0;
    }),
  };

  function totalSelected() {
    return state.counts.reduce(function (sum, n) {
      return sum + n;
    }, 0);
  }

  function updateVariantInput() {
    if (!variantIdInput || !state.variantId) return;
    variantIdInput.value = state.variantId;
    variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function updatePrice() {
    if (!priceContainer || !state.variantId) return;
    const template = root.querySelector('[data-postcard-price-tpl="' + state.variantId + '"]');
    if (template) {
      priceContainer.innerHTML = template.innerHTML;
    }
  }

  function updateHiddenFields() {
    hiddenFieldsContainer.innerHTML = '';

    const sizeField = document.createElement('input');
    sizeField.type = 'hidden';
    sizeField.name = 'properties[Set-Größe]';
    sizeField.value = state.target + ' Postkarten';
    hiddenFieldsContainer.appendChild(sizeField);

    let motifIndex = 0;
    motifs.forEach(function (motif, i) {
      const label = motif.querySelector('.postcard-motif__label').textContent.trim();
      for (let n = 0; n < state.counts[i]; n++) {
        motifIndex += 1;
        const field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'properties[Motiv ' + motifIndex + ']';
        field.value = label;
        hiddenFieldsContainer.appendChild(field);
      }
    });
  }

  function updateAddButton() {
    const selected = totalSelected();
    const motifsComplete = state.target > 0 && selected === state.target;
    const shouldDisable = !motifsComplete || !state.variantAvailable;

    if (!addButton) return;

    if (shouldDisable) {
      addButton.setAttribute('disabled', 'disabled');
      if (buttonsContainer) buttonsContainer.classList.add('is-disabled');
      if (addButtonText && !state.variantAvailable) {
        addButtonText.textContent = 'Ausverkauft';
      }
    } else {
      addButton.removeAttribute('disabled');
      if (buttonsContainer) buttonsContainer.classList.remove('is-disabled');
      if (addButtonText) {
        addButtonText.textContent = (window.theme && window.theme.localize)
          ? window.theme.localize('ADD_TO_CART')
          : addButtonText.textContent;
      }
    }
  }

  function render() {
    const selected = totalSelected();
    progressEl.textContent = selected;
    targetEl.textContent = state.target;

    motifs.forEach(function (motif, i) {
      const count = state.counts[i];
      const badge = motif.querySelector('[data-postcard-motif-count]');
      const qtyLabel = motif.querySelector('[data-postcard-motif-qty]');
      const increaseBtn = motif.querySelector('[data-postcard-motif-increase]');
      const decreaseBtn = motif.querySelector('[data-postcard-motif-decrease]');

      motif.dataset.selected = count > 0 ? 'true' : 'false';
      qtyLabel.textContent = count;
      badge.textContent = count;
      badge.hidden = count === 0;
      decreaseBtn.disabled = count === 0;
      increaseBtn.disabled = selected >= state.target;
    });

    updateHiddenFields();
    updateAddButton();
  }

  function jumpToGalleryMedia(mediaId) {
    if (!mediaId) return;

    // Bevorzugt: passendes Thumbnail anklicken (nutzt die bestehende Galerie-Logik,
    // funktioniert wenn die Galerie-Navigation auf "Thumbnails" steht)
    const thumbImg = document.querySelector('.media-gallery__thumb-image[data-media-id="' + mediaId + '"]');
    if (thumbImg) {
      const thumbButton = thumbImg.closest('button.thumbnail');
      if (thumbButton) {
        thumbButton.click();
        return;
      }
    }

    // Fallback (z. B. Grid-Ansicht ohne Thumbnail-Navigation): zum Bild scrollen
    const slide = document.querySelector('.media-gallery__item[data-media-id="' + mediaId + '"]');
    if (slide) {
      slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function setCount(index, newCount) {
    const current = state.counts[index];
    const selected = totalSelected();
    const clamped = Math.max(0, newCount);

    if (clamped > current && selected >= state.target) return;

    state.counts[index] = clamped;
    render();
  }

  function readSelectedSize() {
    const checked = sizeInputs.find(function (input) {
      return input.checked;
    });
    if (!checked) return;

    state.target = parseInt(checked.value, 10) || 0;
    state.variantId = parseInt(checked.dataset.variantId, 10);
    state.variantAvailable = checked.dataset.available === 'true';

    // Beim Wechsel der Set-Größe wird die Motivauswahl zurückgesetzt
    state.counts = state.counts.map(function () {
      return 0;
    });

    updateVariantInput();
    updatePrice();
    render();
  }

  sizeInputs.forEach(function (input) {
    input.addEventListener('change', readSelectedSize);
  });

  motifs.forEach(function (motif, i) {
    motif.querySelector('[data-postcard-motif-increase]').addEventListener('click', function () {
      setCount(i, state.counts[i] + 1);
    });
    motif.querySelector('[data-postcard-motif-decrease]').addEventListener('click', function () {
      setCount(i, state.counts[i] - 1);
    });
    motif.querySelector('[data-postcard-motif-add]').addEventListener('click', function () {
      setCount(i, state.counts[i] + 1);
      jumpToGalleryMedia(motif.dataset.mediaId);
    });
  });

  readSelectedSize();
}